import { KeyValue } from '@angular/common';
import { BankCountryConfig } from "../../models/bank.model";

/** State for bank objects */
export interface BankState {
    bankCountries: KeyValue<string, BankCountryConfig[]>[];
}

export const initialState: BankState = {
    bankCountries: []
};